import React, { useState, useRef } from 'react';
import ImageWithBaseApi from '../../common/mediaRender/ImageWithBaseApi';

const GalleryModal = ({ currentItem, handlePrevious, handleNext, setShowModal, publicUrl }) => {
    const [zoomStyle, setZoomStyle] = useState({});
    const zoomRef = useRef(null);

    const handleMouseMove = (e) => {
        requestAnimationFrame(() => {
            const container = zoomRef.current.getBoundingClientRect();
            const x = Math.min(Math.max((e.clientX - container.left) / container.width, 0), 1) * 100;
            const y = Math.min(Math.max((e.clientY - container.top) / container.height, 0), 1) * 100;
            setZoomStyle({
                transformOrigin: `${x}% ${y}%`,
                transform: 'scale(1.8)',
            });
        });
    };

    const handleMouseEnter = () => {
        setZoomStyle((prevStyle) => ({
            ...prevStyle,
            transition: 'transform 0.2s ease, transform-origin 0.2s ease',
        }));
    };

    const handleMouseLeave = () => {
        setZoomStyle({});
    };

    const videoId = currentItem.src.includes('youtube.com') ? currentItem.src.split('v=')[1] : null;

    return (
        <div className="custom-modal" onClick={() => setShowModal(false)}>
            <div className="modal-gallery" onClick={(e) => e.stopPropagation()}>
                <button className="close-button" onClick={() => setShowModal(false)} aria-label="Close">&times;</button>
                <button className="nav-button prev" style={{ zIndex: '100' }} onClick={handlePrevious} aria-label="Previous">
                    <i className="fas fa-chevron-left"></i>
                </button>
                <button className="nav-button next" style={{ zIndex: '100' }} onClick={handleNext} aria-label="Next">
                    <i className="fas fa-chevron-right"></i>
                </button>
                {currentItem.type === 'video' && videoId ? (
                    <div className="video-wrapper">
                        <iframe
                            src={`https://www.youtube.com/embed/${videoId}`}
                            className="modal-media"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={`YouTube video player - ${videoId}`}
                        ></iframe>
                    </div>
                ) : (
                    <div
                        className="modal-media-container"
                        ref={zoomRef}
                        onMouseMove={handleMouseMove}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        style={{
                            overflow: 'hidden',
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <ImageWithBaseApi
                            src={currentItem.src}
                            alt=""
                            className="modal-media"
                            loadingIconFontSize="60px"
                            ladingClass="loading-class"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                ...zoomStyle,
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default GalleryModal;